'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _bdcoreData = require('@bd/bdcore-data');

var _bdcoreData2 = _interopRequireDefault(_bdcoreData);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _Community = require('./Community');

var _Community2 = _interopRequireDefault(_Community);

var _Blogpost = require('./Blogpost');

var _Blogpost2 = _interopRequireDefault(_Blogpost);

var _Page = require('./Page');

var _Page2 = _interopRequireDefault(_Page);

var _Home = require('./Home');

var _Home2 = _interopRequireDefault(_Home);

var _Plan = require('./Plan');

var _Plan2 = _interopRequireDefault(_Plan);

var _Custom = require('./Custom');

var _Custom2 = _interopRequireDefault(_Custom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */
var constructors = {
  blogpost: _Blogpost2.default,
  community: _Community2.default,
  page: _Page2.default,
  home: _Home2.default,
  plan: _Plan2.default,
  custom: _Custom2.default
};

var config = [{
  key: 'ld+json',
  type: 'multiple',
  uniqueFields: ['@bdType'] // @bdType will be removed before displaying the data
}, {
  key: 'meta',
  type: 'multiple',
  uniqueFields: ['name', 'property']
}, {
  key: 'link',
  type: 'multiple',
  uniqueFields: ['href']
}, {
  key: 'title',
  type: 'single'
}];

function merge(a, b) {
  return config.reduce(function (result, _ref) {
    var key = _ref.key,
        type = _ref.type,
        uniqueFields = _ref.uniqueFields;

    if (type === 'single') {
      result[key] = b[key] || a[key] || { content: undefined, attrs: [] };
    } else if (type === 'multiple') {
      result[key] = [];
      var grouped = (0, _lodash.groupBy)((0, _lodash.get)(a, key, []).concat((0, _lodash.get)(b, key, [])), function (v) {
        return uniqueFields.reduce(function (val, field) {
          return val || (0, _lodash.get)(v, field);
        }, false);
      });

      var combined = (0, _keys2.default)(grouped).map(function (id) {
        return grouped[id].length === 1 ? grouped[id][0] : grouped[id].reduce(function (v, obj) {
          return (0, _extends3.default)({}, v, obj);
        }, {});
      });

      result[key] = combined;
    }

    return result;
  }, {});
}

function PageHelmetWrapper(props) {
  var builder = props.builder,
      children = props.children;

  var propKeys = (0, _keys2.default)(props).filter(function (key) {
    return props[key];
  });
  var constructorKeys = (0, _keys2.default)(constructors);

  var _intersection = (0, _lodash.intersection)(propKeys, constructorKeys),
      _intersection2 = (0, _slicedToArray3.default)(_intersection, 1),
      match = _intersection2[0];

  var Constructor = constructors[match];
  var configElements = _bdcoreUtilities.ConfigStore.getConfig('PageHelmet', {});

  var defaults = merge({
    'ld+json': [{
      '@bdType': 'Company',
      '@context': 'http://schema.org',
      '@type': ['Organization', 'LocalBusiness', 'HomeAndConstructionBusiness'],
      address: (0, _extends3.default)({}, (0, _lodash.get)(builder, 'address'), { order: undefined }),
      description: (0, _lodash.get)(builder, 'description'),
      name: (0, _lodash.get)(builder, 'name'),
      telephone: (0, _lodash.get)(builder, 'telephone'),
      image: (0, _lodash.get)(builder, 'logo.contentUrl'),
      logo: (0, _extends3.default)({}, (0, _lodash.get)(builder, 'logo'), { url: 'https://www.' + (0, _lodash.get)(builder, 'authDomain') }),
      geo: {
        '@type': 'GeoCoordinates',
        latitude: (0, _lodash.get)(builder, 'geoIndexed[1]'),
        longitude: (0, _lodash.get)(builder, 'geoIndexed[0]')
      },
      sameAs: (0, _lodash.get)(builder, 'socialLinks', []),
      url: 'https://www.' + (0, _lodash.get)(builder, 'authDomain')
    }]
  }, configElements);

  var elements = defaults;

  try {
    if (Constructor) {
      var result = Constructor((0, _extends3.default)({ defaults: defaults }, props));

      elements = merge(defaults, result);
    }

    if (props.elements) {
      elements = merge(elements, props.elements);
    }
  } catch (e) {
    console.error(e); // eslint-disable-line no-console
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _bdcoreUtilities.Helmet,
      null,
      (0, _lodash.get)(elements, 'ld+json', []).map(function (obj, i) {
        return _react2.default.createElement(
          'script',
          { key: i.toString(), type: 'application/ld+json' },
          (0, _stringify2.default)((0, _extends3.default)({}, obj, { '@bdType': undefined }))
        );
      }),
      (0, _lodash.get)(elements, 'meta', []).map(function (obj, i) {
        return _react2.default.createElement('meta', (0, _assign2.default)({ key: i.toString() }, obj));
      }),
      (0, _lodash.get)(elements, 'link', []).map(function (obj, i) {
        return _react2.default.createElement('link', (0, _assign2.default)({ key: i.toString() }, obj));
      }),
      (0, _lodash.get)(elements, 'title', []) && _react2.default.createElement(
        'title',
        (0, _lodash.get)(elements, 'title.attrs', {}),
        (0, _lodash.get)(elements, 'title.content', 'MISSING TITLE')
      ),
      match === 'custom' && children
    )
  );
}

PageHelmetWrapper.propTypes = {
  builder: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node,
  elements: _propTypes2.default.object
};

PageHelmetWrapper.defaultProps = {
  builderTitleOnly: false,
  children: undefined,
  elements: undefined
};

exports.default = (0, _bdcoreData2.default)({
  builder: true,
  router: true,
  home: true,
  community: true
}, {
  required: {
    builder: true,
    router: true
  }
})(PageHelmetWrapper);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-pagehelmet/build/index.js
// module id = 79
// module chunks = 0